import { Dialog, Fab, List, ListItem, styled } from "@mui/material";

export const MessageList = styled(List)({
  flexGrow: 1,
  overflow: "auto",
  padding: 8,
  maxHeight: 300,
});

export const MessageItem = styled(ListItem)(({ theme, isUser }) => ({
  justifyContent: isUser ? "flex-end" : "flex-start",
  mb: 1,
  "& .MuiListItemText-root": {
    backgroundColor: isUser
      ? theme.palette.primary.main
      : theme.palette.grey[200],
    color: isUser ? "#fff" : "inherit",
    padding: "8px 12px",
    borderRadius: 16,
    maxWidth: "70%",
  },
}));

export const FloatingChatButton = styled(Fab)(() => ({
  position: "fixed",
  right: 24,
  bottom: 24,
  zIndex: 1300,
  width: 60,
  height: 60,
}));

export const ChatDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    height: 500,
    maxHeight: "90vh",
  },
});
